import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { StorageService } from '../../shared/services/storage.service';
import { TranslateService } from '../../services/translate.service';


@Component({
    selector: 'dhs-langugage-selection',
    templateUrl: './language-selection.component.html',
    styleUrls: ['./language-selection.component.scss'],
    standalone: false
})
export class LanguageSelectionComponent implements OnInit {
    @Input() languageList = [{languageCode: "en", languageName: "English"}];
    selectedLanguage: string;
    @Output() languageVal = new EventEmitter<any>();
    constructor(private translateService: TranslateService){
    }

    ngOnInit() {
        this.translateService.getLanguage((data) => {
            this.selectedLanguage = data;
        });
    }

    languageChange(event){
        //resetting saved filter in case of language change. 
        const prefix = 'f__k';
        let matchedValue: string | null = null;
        let filterKey = '';
        for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
            if (key && key.startsWith(prefix)) {
                matchedValue = sessionStorage.getItem(key);
                filterKey = key;
                break;
            }
        }
        console.log('Matched key:', filterKey);
        console.log('Matched value:', matchedValue);
        if(filterKey && filterKey!=''){
            sessionStorage.removeItem(filterKey);
        }
        this.languageVal.emit(event.target.value);
    }
}